export default
    {
        path: '/trade/detail/apply',
        component: require('./index').default,
        parent: 'root',
        meta: {
            isLogin: true,
            title:'项目报名'
        },
        name:'tradeApply'
    }
